import React, { useState } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  Avatar,
  Alert,
  Snackbar,
  Paper,
  Stack,
  CircularProgress,
  Grid,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { RECOVER_PASSWORD } from "../../graphql/gqlUser";
import AuthWrapper from "../../components/buildingBlocks/auth-wrapper";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [showSnackbar, setShowSnackbar] = useState<boolean>(false);
  const navigate = useNavigate();

  const [recoverPassword] = useMutation(RECOVER_PASSWORD, {
    onCompleted: () => {
      setSuccess("Password reset link has been sent to your email");
      setShowSnackbar(true);
      setTimeout(() => {
        navigate("/");
      }, 2000);
    },
    onError: (data) => {
      setError(data.message);
    },
  });

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (email === "") {
      setError("Email is required");
      return;
    }

    setError(null);
    setLoading(true);
    setSuccess(null);

    await recoverPassword({ variables: { email } });

    setLoading(false);
  };

  return (
    <AuthWrapper title="Forgot Password">
      <Box>
        {error && (
          <Alert severity="error" sx={{ width: "100%" }}>
            {error}
          </Alert>
        )}

        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{ width: "100%" }}
        >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="Email Address"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            color="secondary"
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            sx={{ mt: 2 }}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Send Password Reset Link"
            )}
          </Button>

          <Grid container justifyContent="center" sx={{ mt: 2 }}>
            <Grid
              item
              sx={{
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
              onClick={() => navigate("/login")}
            >
              Go back to Sign in
            </Grid>
          </Grid>
        </Box>
        <Snackbar
          open={showSnackbar}
          autoHideDuration={4000}
          onClose={() => setShowSnackbar(false)}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          message={success}
        />
      </Box>
    </AuthWrapper>
  );
};

export default ForgotPasswordPage;
